import { OrganizationUIStyle } from '@/api/rest/resources/types/organization';
import { Workstream } from '@/api/rest/resources/types/workstreams';
import { usePathSet } from '@/hooks/usePathSet';
import { useUIStyle } from '@/hooks/useUIStyle';
import { buildPath } from '@/utils/buildPath';

export const useWorkstreamTargetUrl = (workstream: Workstream) => {
  const hasConservationUIStyle = useUIStyle(OrganizationUIStyle.CONSERVATION);
  const pathSet = usePathSet();

  if (hasConservationUIStyle) {
    return buildPath(pathSet.plots, { queryParams: { workstreamId: workstream.id } });
  }

  return buildPath(pathSet.home, { queryParams: { workstreamId: workstream.id } });
};
